import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface INotificationTemplate {
  id: string;
  businessId: string;
  templateKey: string;
  channel: string;
  language: string;
  subject: string | null;
  body: string;
  description: string | null;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type NotificationChannel = "SMS" | "EMAIL" | "PUSH";

export interface ICreateNotificationTemplateInput {
  templateKey: string;
  channel: NotificationChannel;
  language: string;
  subject?: string | null;
  body: string;
  description?: string | null;
  isActive: boolean;
}

export const list = async (data?: {
  filter?: { channel?: string; isActive?: boolean | null };
  offset?: { limit: number; skip: number };
}) =>
  httpRequest.post("/ord/notification-template/list", (data ?? {}) as never) as Promise<{
    rows: INotificationTemplate[];
    count: number;
  }>;

export const create = async (
  input: ICreateNotificationTemplateInput | Partial<INotificationTemplate>,
) =>
  httpRequest.post("/ord/notification-template", input as never);

// patch accepts either the stricter create-input type or a partial of the
// full model record (for callers that already hold an INotificationTemplate).
export const update = async (
  id: string,
  patch: Partial<ICreateNotificationTemplateInput> | Partial<INotificationTemplate>,
) =>
  httpRequest.put(`/ord/notification-template/${id}`, patch as never);

export const remove = async (id: string) =>
  httpRequest.del(`/ord/notification-template/${id}`);

// Spec §17 / B6 — render the template's Handlebars body against a sample
// `variables` map and return the rendered text without sending. Used by
// the editor preview pane.
export interface IRenderTestInput {
  body: string;
  subject?: string | null;
  variables?: Record<string, unknown>;
}

export interface IRenderTestResult {
  body: string;
  subject?: string | null;
  errors?: string[];
}

export const renderTest = async (input: IRenderTestInput): Promise<IRenderTestResult> =>
  httpRequest.post("/ord/notification-template/render-test", input as never);
